import { render, staticRenderFns } from "./EstadisticoCitas.vue?vue&type=template&id=3fb00ce0&"
import script from "./EstadisticoCitas.vue?vue&type=script&lang=js&"
export * from "./EstadisticoCitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports